module.exports = __webpack_public_path__ + "img/btn_right.70e256fb.png";